"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.buildYup = buildYup;
exports.validateField = validateField;
exports.validateForm = validateForm;
exports.validations = validations;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var yup = _interopRequireWildcard(require("yup"));

function buildYup(validators, defaultValue) {
  validators = validators.map(function (validator) {
    return validator.split('.');
  }).reduce(function (res, arr) {
    return res.concat(arr);
  });

  var validatorFunc = function validatorFunc(validator) {
    return /^[^\(]+/.exec(validator)[0];
  };

  var validatorArgs = function validatorArgs(validator) {
    if (/\((.+?)\)/.test(validator)) {
      var argsString = /\((.+?)\)/.exec(validator)[1];
      var args = argsString.split(',').map(function (str) {
        return str.trim();
      }).map(function (str) {
        return eval(str);
      });
      return args;
    } else {
      return [];
    }
  };

  var res = validators.reduce(function (obj, validator) {
    return obj[validatorFunc(validator)].apply(obj, (0, _toConsumableArray2["default"])(validatorArgs(validator)));
  }, yup);
  if (res && defaultValue) res = res["default"](defaultValue);
  return res;
}

function validateField(_x, _x2, _x3) {
  return _validateField.apply(this, arguments);
}

function _validateField() {
  _validateField = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(path, store, block) {
    var field, fieldYup, dict, isSuccess, value;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            field = store.getValue(path);
            fieldYup = buildYup(block.validators);
            dict = {};
            isSuccess = true;
            value = '';

            if (field.hasOwnProperty('value')) {
              value = field.value;
            }

            _context.next = 8;
            return fieldYup.validate(value)["catch"](function (err) {
              console.log('validate error', err);
              dict[path + '/isValid'] = false;
              dict[path + '/errorMessage'] = err.errors[0];
              isSuccess = false;
            })["finally"](function (value) {
              if (isSuccess) {
                dict[path + '/isValid'] = true;
              }
            });

          case 8:
            _context.next = 10;
            return store.setValues(dict);

          case 10:
            return _context.abrupt("return", isSuccess);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _validateField.apply(this, arguments);
}

function validateForm(_x4, _x5, _x6) {
  return _validateForm.apply(this, arguments);
}

function _validateForm() {
  _validateForm = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(path, store, block) {
    var isValid, check;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isValid = true;

            if (!(block && block.hasOwnProperty('validators') && block.validators.length > 0)) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return validateField(path, store, block);

          case 4:
            if (_context2.sent) {
              _context2.next = 6;
              break;
            }

            isValid = false;

          case 6:
            if (!(block && block.hasOwnProperty('content'))) {
              _context2.next = 11;
              break;
            }

            _context2.next = 9;
            return _promise["default"].all(block.content.map(function (field) {
              return validateForm(path + (field.path ? field.path : ''), store, field);
            }));

          case 9:
            check = _context2.sent;
            if (!check.every(function (el) {
              return el;
            })) isValid = false;

          case 11:
            return _context2.abrupt("return", isValid);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _validateForm.apply(this, arguments);
}

function validations(components) {
  var schema = {};
  var keys = (0, _keys["default"])(components);
  keys.forEach(function (key) {
    var _components$key = components[key],
        validators = _components$key.validators,
        defaultValue = _components$key.defaultValue;
    if (validators && validators.length !== 0) schema[key] = buildYup(validators, defaultValue);
  });
  return yup.object().shape(schema);
}